import httpCore from "@/network/httpCore";
import {formatMessage} from "@/locale"
import { 
    ErrorCode, 
    ErrorInfo, 
    MethodType,
    RequestContentType,
    ContentType,
    RspInfo,
    ResponseProp
} from "@/network/http";
import router from '@/router'
import qs from "qs";
import merge from "lodash/merge";
import { getToken } from "@/utils/index";
import { md5 } from "@/utils/crypt";

interface RequestProp {
    url: string;
    method: MethodType;
    requestContentType?: RequestContentType,
    contentType?: ContentType;
    urlParams?: any;
    headers?: any;
    data?: any;
    callback?: (errorInfo: ErrorInfo, data: any) => void;
}

/**
 * 可选参数
 */
interface OptionParams {
    contentType?: ContentType;
    urlParams?: any;
    headers?: any;
}

/**
 * GET请求
 * @param url 
 * @param callback 
 * @param options 
 */
export const getRequest = (url: string, callback?: (errorInfo: ErrorInfo, data: any) => void, options?: OptionParams) => {
    request({
        url,
        method: MethodType.GET,
        requestContentType: RequestContentType.JSON,
        contentType: options?.contentType,
        urlParams: options?.urlParams,
        headers: options?.headers,
        callback
    });
};

/**
 * form表单请求
 * @param url 
 * @param data 
 * @param callback 
 * @param options 
 */
export const postFormRequest = (url: string, data: any, callback?: (errorInfo: ErrorInfo, data: any) => void, options?: OptionParams) => {
    request({
        url,
        method: MethodType.POST,
        requestContentType: RequestContentType.FORM,
        contentType: options?.contentType,
        urlParams: options?.urlParams,
        headers: options?.headers,
        data,
        callback
    });
};

/**
 * POST json字符串
 * @param url 
 * @param data 
 * @param callback 
 * @param options 
 */
export const postRequest = (url: string, data: any, callback?: (errorInfo: ErrorInfo, data: any) => void, options?: OptionParams) => {
    request({
        url,
        method: MethodType.POST,
        requestContentType: RequestContentType.JSON,
        contentType: options?.contentType,
        urlParams: options?.urlParams,
        headers: options?.headers,
        data,
        callback
    });
};

/**
 * htt请求
 */
export const request = (requestProp: RequestProp) => {
  let requestContentType = requestProp.requestContentType;
  if (!requestContentType) {
      requestContentType = RequestContentType.JSON;
  } else {

  }

  console.log(requestProp.data);
  let reqHeader = adornHeader(requestProp.headers)
  let reqData = adornData(requestProp.data, false, requestContentType);

  if (process.env.VUE_APP_OPEN_SIGN) {
    //请求需要签名
    let signData: string = sign(reqData);
    reqHeader.sign = signData;
  }
  

  //签名
  
  httpCore({
      url: createUrl(requestProp.url),
      method: requestProp.method,
      data: reqData,
      params: adornParams(requestProp.urlParams, false),
      headers: reqHeader
  }).then((data: any) => {
      let responseData: ResponseProp = {
          rspInfo: {
              code: data.rspInfo ? data.rspInfo.code : data.retInfo.errorCode,
              msg: data.rspInfo ? data.rspInfo.msg : data.retInfo.note,
          },
          data: data.data
      }

      console.log(data);

    if (responseData.rspInfo.code === "000000") {
      //返回数据正常
      try {
        requestProp.callback && requestProp.callback(getLocalErrorCode(responseData.rspInfo), responseData.data);
      } catch(e) {

      }
    } else if (responseData.rspInfo.code === "201004") {
      //登录超时，统一跳转到指定界面
      router.push({ name: 'login' })
    } else if (responseData.rspInfo.code) {
      //其他有错误码的结果
      try {
        requestProp.callback && requestProp.callback(getLocalErrorCode(responseData.rspInfo), null);
      } catch(e) {
      }
    } else {
      //其他错误
      try {
        requestProp.callback && requestProp.callback({
          errorCode: ErrorCode.ERROR,
          msg: formatMessage({id:"message.common.networkError"})
        }, null);
      } catch(e) {

      }
    }
  }).catch((e) => {
    requestProp.callback && requestProp.callback({
      errorCode: ErrorCode.ERROR, 
      msg: formatMessage({id:"message.common.networkError"})
    }, null);
  });
};

/**
 * 生成URL
 */
const createUrl = (actionName:string) => {
  let url = null;

  if (actionName.indexOf("http") === 0) {
    return actionName;
  }

  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  if (process.env.NODE_ENV !== "production" && process.env.VUE_APP_OPEN_PROXY) {
    //url = "/proxyApi/" + actionName;
    url = process.env.VUE_APP_BASE_SERVER + actionName;
  } else {
    url = process.env.VUE_APP_BASE_SERVER + actionName;
  }

  return url;
};

/**
 * get请求参数处理
 * @param params 参数对象
 * @param openDefultParams 是否开启默认参数
 */
const adornParams = (params:any = {}, openDefultParams:boolean = true) => {
    let defaults = {
      t: new Date().getTime()
    };
    return openDefultParams ? merge(defaults, params) : params;
};
  
/**
 * 请求HTTP头部信息
 * @param headers 
 * @param openDefultHeaders 
 */
const adornHeader = (headers:any = {}, openDefultHeaders:boolean = true) => {
    let defaults = {
      t: new Date().getTime(),
      token: getToken()
    };
    return openDefultHeaders ? merge(defaults, headers) : headers;
};

/**
 * post请求数据处理
 * @param data 数据对象
 * @param openDefultdata 是否开启默认数据
 * @param contentType 数据格式
 */
const adornData = (data:any = {}, openDefultdata:boolean = true, contentType:RequestContentType = RequestContentType.JSON) => {
    let defaults = {
      t: new Date().getTime()
    };
    data = openDefultdata ? merge(defaults, data) : data;
    return contentType === RequestContentType.JSON ? JSON.stringify(data) : qs.stringify(data);
};

/**
 * 转换错误码对象
 * @param rspInfo 
 */
const getLocalErrorCode = (rspInfo: RspInfo): ErrorInfo => {
    let code = rspInfo.code;
    let localCode: ErrorCode = ErrorCode.SUCCESS;

    if (code === '000000') {
        localCode = ErrorCode.SUCCESS;
    } else if (code === '201004') {
        localCode = ErrorCode.TIMEOUT;
    } else {
        localCode = ErrorCode.ERROR;
    }

    return {
        errorCode: localCode,
        msg: rspInfo.msg
    }
}

/**
 * 签名
 * @param date 
 */
const sign = (date: string): string => {
  let signData = md5(date + process.env.VUE_APP_APP_SEC);
  return signData;
}

/**
 * 验签
 * @param date 
 */
const verifySign = (date: string, signData: string): boolean => {
  let localSignData = md5(date + process.env.VUE_APP_APP_SEC);
  return signData && signData === localSignData ? true : false;
}